import { useState } from 'react';
import { formatGroups } from 'utils/formatters';
import { useStoreSelector } from 'v3/data/store';
import { setGroupAdminSelected } from 'v3/data/store/groupAdmin/actions';
import { IGroupAdminItem, IGroupsAdminList } from 'v3/data/store/groupAdmin/types';
import { EditIcon } from 'v3/shared/components/MobileTable/styles';
import { GroupAdminModal } from 'v3/shared/components/Modal/GroupAdminModal';
import { IModal, Mode } from 'v3/shared/components/Modal/GroupAdminModal/types';
import { NoItemsFound } from 'v3/shared/components/NoItemsFound';
import { SubtitleMediumBoldStyled, SubtitleMediumStyled } from 'v3/shared/typography/SubtitleMedium/styles';
import { AlignStatusContainer, BoxCustom, Container, Content } from './styles';

interface GroupsAdminTableProps {
  groupsAdminList: IGroupsAdminList;
}

export const GroupAdminMobileTable: React.FC<GroupsAdminTableProps> = ({ groupsAdminList }) => {
  const { allGroups, groups } = useStoreSelector((store) => store.groupAdmin);

  const [groupAdminModal, setGroupAdminModal] = useState<IModal>({
    active: false,
    cancelButton: 'Cancelar',
    saveButton: 'Salvar',
    title: 'Editar grupo admin',
    mode: Mode.Edit,
  });

  const handleOpenModal = (groupAdmin: IGroupAdminItem) => {
    setGroupAdminSelected(groupAdmin);
    setGroupAdminModal({ ...groupAdminModal, active: true });
  };

  if (!groupsAdminList || groupsAdminList.items.length === 0) {
    return <NoItemsFound />;
  }

  return (
    <BoxCustom>
      {groupsAdminList.items.map((item) => (
        <Container>
          <Content>
            <SubtitleMediumBoldStyled>Nome</SubtitleMediumBoldStyled>
            <SubtitleMediumStyled>{item.name}</SubtitleMediumStyled>
          </Content>
          <Content>
            <SubtitleMediumBoldStyled>E-mail</SubtitleMediumBoldStyled>
            <SubtitleMediumStyled>{item.email}</SubtitleMediumStyled>
          </Content>
          <Content>
            <SubtitleMediumBoldStyled>Grupo</SubtitleMediumBoldStyled>
            <SubtitleMediumStyled>{formatGroups(item.groupAdmin)}</SubtitleMediumStyled>
          </Content>
          <AlignStatusContainer>
            <Content>
              <SubtitleMediumBoldStyled>Ações</SubtitleMediumBoldStyled>
              <SubtitleMediumStyled>Editar</SubtitleMediumStyled>
            </Content>
            <Content>
              <EditIcon
                onClick={() => {
                  handleOpenModal(item);
                }}
              />
            </Content>
          </AlignStatusContainer>
        </Container>
      ))}

      <GroupAdminModal
        modal={groupAdminModal}
        fullStoreGrouplist={allGroups}
        adminStoreGroupList={groups}
        onClose={() => setGroupAdminModal({ ...groupAdminModal, active: false })}
        onConfirm={() => setGroupAdminModal({ ...groupAdminModal, active: false })}
      ></GroupAdminModal>
    </BoxCustom>
  );
};
